// extracted by mini-css-extract-plugin
export default {"cardTitle":"styles_cardTitle__RZm6u"};